import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center"
  },
}));

export const NavBar = _ => {
  const classes = useStyles();
  let history = useHistory();
  const pushLink = link => {
    history.push(link);
  }
  
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar variant="dense">
          <Typography variant="h6" color="inherit">
            <img src={ require('../../images/logo.png') } alt="Logo" height="88" width="88" /> Interactive Machine Learning
          </Typography>
        </Toolbar>
        <div>
          <Button style={{ width: '14.25%' }} color="inherit" onClick={()=>{pushLink('/DWM-Mini-Project')}}>Home</Button>
          <Button style={{ width: '14.25%' }} color="inherit" onClick={()=>{pushLink('/DWM-Mini-Project/view-dataset')}}>View Dataset</Button>
          <Button style={{ width: '14.25%' }} color="inherit" onClick={()=>{pushLink('/DWM-Mini-Project/lin-reg')}}>Linear Regression</Button>
          <Button style={{ width: '14.25%' }} color="inherit" onClick={()=>{pushLink('/DWM-Mini-Project/log-reg')}}>Logistic Regression</Button>
          <Button style={{ width: '14.25%' }} color="inherit" onClick={()=>{pushLink('/DWM-Mini-Project/svm')}}>Support Vector Machine</Button>
          <Button style={{ width: '14.25%' }} color="inherit" onClick={()=>{pushLink('/DWM-Mini-Project/nb')}}>Naive Bayes</Button>
          <Button style={{ width: '14.25%' }} color="inherit" onClick={()=>{pushLink('/DWM-Mini-Project/k-means')}}>K-Means Clustering</Button>
        </div>
      </AppBar> 
    </div>      
  );
}



// WEBPACK FOOTER //
// ./src/component/navBar/NavBar.js